export enum ConversationModes {
    Silverfin = 'SILVERFIN',
    FintraxData = 'FINTRAX_DATA',
    UserData = 'USER_DATA',
    SharePoint = 'SHAREPOINT',
}
